import { Component } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { of } from 'rxjs/observable/of';
import { catchError, finalize, flatMap, tap } from 'rxjs/operators';

import { LoadingProvider } from '../../providers/loading/loading';
import { SystemSessionServiceProvider } from '../../providers/servicer/system-session-service';

import { LoginApiParameter } from '../../providers/servicer/models/login-api-parameter';

/**
 * [システム] ログイン.
 */
@Component({
  selector: 'login',
  templateUrl: 'login.html'
})
export class LoginComponent {
  /** ログイン情報. */
  loginParam: LoginApiParameter = {
    loginId: '',
    password: ''
  };

  constructor(
    public toast: ToastController,
    public loading: LoadingProvider,
    public systemSessionService: SystemSessionServiceProvider
  ) { }

  /**
   * ログイン処理.
   */
  login() {
    let loadingToken = null;

    // ログインAPI呼び出し
    this.loading.start().pipe(
      tap((token) => loadingToken = token),
      flatMap(() => this.systemSessionService.login(this.loginParam)),
      catchError((error) => {
        /** 異常. */
        console.debug(error);
        this.loginError(error);
        return of(null);
      }),
      finalize(() => {
        // ローディング停止
        this.loading.stop(loadingToken);
      })
    ).subscribe();
  }

  /**
   * ログインエラー.
   *
   * エラーメッセージのアラートを表示する
   * @param error エラー
   */
  private loginError(error: any) {
    let msg = 'ログインに失敗しました。';
    if (error && error.error && error.error.message) {
      msg = error.error.message;
    }
    this.toast.create({
      message: msg,
      showCloseButton: true,
      closeButtonText: '閉じる',
      position: 'top'
    }).present();
  }
}



// WEBPACK FOOTER //
// ./src/components/login/login.ts